import InsertTeachingPeriodButton from './InsertTeachingPeriodButton';
export default InsertTeachingPeriodButton;
